import React from 'react'
import { ReactSVG } from 'react-svg'

interface Props {
    height: number | string,
    minHeight?: number | string,
    width: number | string,
    fill?: string,
    path?: string,
    stroke?: string,
    src: any,
    className?: any,
    onClick?: () => void,
    style?: any
}

function SvgWrapper({
    height,
    minHeight,
    width,
    fill = 'transparent',
    path,
    stroke,
    src,
    className,
    onClick,
    style,
}: Props) {

    return (
        <ReactSVG
            onClick={onClick}
            style={{
                ...style,
                height: parseInt(height?.toString()),
                ...(minHeight ? { minHeight: parseInt(minHeight?.toString()) } : {}), 
                width: parseInt(width?.toString()),
                fill,
                ...(stroke ? { stroke } : {}),
                ...(path ? { path } : {}),
            }}
            className={`fill-svg ${stroke && path
                    ? 'stroke-path'
                    : fill && path
                        ? 'fill-path'
                        : ''} ${className ?? ''}`}
            src={src}
        />
    )
}

export default SvgWrapper
